const accessSuperAdmin = {
    // Company Routes
    ADD_COMPANY: { name: 'Add Company', path: '/add-company' },
    UPDATE_COMPANY: { name: 'Edit Company', path: '/edit-company' },
    COMPANY_LIST: { name: 'Company', path: '/company-list' },
    DELETE_COMPANY: { name: 'Delete Company', path: '/delete-company' },

    // Company User Routes
    ADD_COMPANY_USER: { name: 'Add Company User', path: '/add-company-user' },
    UPDATE_COMPANY_USER: { name: 'Edit Company User', path: '/edit-company-user' },
    COMPANY_USER_LIST: { name: 'Company User', path: '/company-user-list' },
    DELETE_COMPANY_USER: { name: 'Delete Company User', path: '/delete-company-user' },
}

export default accessSuperAdmin;
